<!-- Modal add holiday -->
<div class="modal fade" id="addHolidayModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content dirI">
            <div class="modal-header">
                <h5 class="modal-title bold txt-navy">ثبت تعطیلی جدید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="d-flex justify-content-between">
                    <div class="col-md-4 col-6 ">
                        <label>تاریخ</label>
                        <form [formGroup]="form">
                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                                <input type="text" formControlName="date" class="form-control shadow text-end"
                                    readonly />
                            </ng-persian-datepicker>
                        </form>
                    </div>
                    <div class="col-md-4 col-6 ">
                        <label>نوع</label>
                        <select class="form-select col-auto pointer" id="holidayType">
                            <option value="0">رسمی</option>
                            <option value="1">آلودگی هوا</option>
                            <option value="2">سایر</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 mt-2">
                    <textarea class="form-control" id="holidayComment" rows="3" placeholder="توضیحات..."></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" (click)="saved.emit()">ذخیره <i class="fa fa-check"></i>
                </button>
                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>

            </div>
        </div>
    </div>
</div>
